import O1HD from "../../../../engines/gameEngine";
import NormalGameManager from "../../manager/NormalGameManager";
import backpackOpenBase from "../backpackOpenBase";
import {getStartWeChatIdByPeople, loveStoryBindPeoples, loveStoryEvent} from "./loveStoryConst";
import loveStoryShareItem from "./loveStoryShareItem";
import {getOneWeChatTriggerTimeLinkById} from "../../config/WeChatTriggerTimeLinkConfig";
import {getOneChitAryById} from "../../config/WeChatChitChatConfig";
import {BUNDLE_SMALL_NAME, getOneBundleOnePrefab} from "../../BundleResourceConfig";
import WeChatFrame from "../weChat/WeChatFrame";
import {backpackUpdataDialog} from "../../config/backpackConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class loveStorySharePrefab extends backpackOpenBase {

    onBackPackOpenPrefab(...arg: any[]) {
        
        super.onBackPackOpenPrefab(arg[0])
    }

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;
    @property({type:cc.Prefab,displayName:"赠送预制体"})
    ShareItemPrefab:cc.Prefab = null;
    @property({type:cc.Node,displayName:"邀请确认节点"})
    inviteMakeSureNode : cc.Node = null;
    @property({type:cc.Node,displayName:"恭喜节点"})
    congratulationsNode : cc.Node = null;
    @property({type:cc.Label,displayName:"恭喜提示"})
    congratulationHintStr : cc.Label = null;

    //当前点击选择的人物
    private _selectPeople : string;

    onLoad(){
        this.loadItems();
        O1HD.on("loveStorySharePrefab.showCongratulationsNode" , this.showCongratulationsNode , this );
    }

    loadItems(){
        for(let p of loveStoryBindPeoples){
            if(!NormalGameManager._instance.loveStroyManager.getOnePeople(p)){
                let node:cc.Node = cc.instantiate(this.ShareItemPrefab);
                let ns = node.getComponent(loveStoryShareItem);
                ns.bindData(p,this.onSelectOne.bind(this));
                node.setParent(this.itemContent);
            }
        }
        this.updateContent();
    }

    updateContent(){
        this.itemContent.children.forEach((n:cc.Node)=>{
            let ns = n.getComponent(loveStoryShareItem);
            let nBindPeople = ns.getBindPeople();
            n.active = !NormalGameManager._instance.loveStroyManager.getOnePeople(nBindPeople);
        });
    }

    onSelectOne(one:loveStoryShareItem){
        NormalGameManager._instance.onOutGoods( 11116 , 1 );
        O1HD.emit("refreshShareCount");
        O1HD.emit(backpackUpdataDialog);
        let oneBindPeople : string = one.getBindPeople();
        this.showInviteMakeSureNode( oneBindPeople );
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.closeThis();
    }

    closeThis(){
        O1HD.emit(loveStoryEvent.UPDATE_LOVESTORYPREFAB);
        this.node.destroy();
        this.node.removeFromParent();
    }

    /**
     * 展示邀请确认节点
     * @param oneBindPeople 绑定的人
     */
    showInviteMakeSureNode( oneBindPeople : string ){
        this._selectPeople = oneBindPeople;
        this.inviteMakeSureNode.active = true;
    }

    /**
     * 邀请确认
     */
    onBtnInviteMakeSure(){
        if(!NormalGameManager._instance.loveStroyManager.getOnePeople( this._selectPeople ) ){
            let peopleDefineEntity = getStartWeChatIdByPeople( this._selectPeople );
            this._addOneWeChat( peopleDefineEntity.startWeChatId ).then();
            // 需要在聊天内容的地方进行特殊的判定 ， 添加最后成功的返回， 单独独立类型，计算当前所有的收入，区分npc 和 自己
            return;
        }
        O1HD.getModules().uiControlModule.showMessageBox("已经绑定过，请选择其他人进行绑定");
    }

    /**
     * 添加一个微信聊天
     * @param weChatId 微信聊天id
     * @private
     */
    private async _addOneWeChat( weChatId : string ){
        let isTrue = NormalGameManager._instance.addOneWeChatTriggerLinkUnShift( `${weChatId}` );
        if(!isTrue){
            return;
        }
        // await this.mGameLayer.mGameLayer.onBtnOpenPrefab(null,"weChat");
        //聊天链
        let link = getOneWeChatTriggerTimeLinkById( weChatId );
        //聊天链的初始端
        let chitChat = getOneChitAryById(link.link[0].id);
        //聊天对象 信息
        let people = NormalGameManager._instance.weChatManager.getOnePeopleById(chitChat.people);
        //聊天对象的队列
        let chitChatQueue = people.peopleChatLinkQueue;
        let chatFramePrefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.WeChatGameBundle, "weChat/prefab/WeChatFrame" );
        let chatFrame = cc.instantiate( chatFramePrefab );
        let cs = chatFrame.getComponent( WeChatFrame );
        if( chitChatQueue.length >0 ){
            // let chitChat = getOneChitAryById(chitChatQueue[0]);
            cs.bindData( chitChatQueue[0],[] , people , ()=>{

            });
        }
        O1HD.Canvas().addChild(chatFrame);
        this.inviteMakeSureNode.active = false;
    }

    /**
     * 邀请取消
     */
    onBtnInviteCancel(){
        this.inviteMakeSureNode.active = false;
    }

    /**
     * 展示恭喜节点
     */
    showCongratulationsNode(  ){
        if ( this.node ) {
            this.congratulationsNode.active = true;
            this.congratulationHintStr.string = `恭喜你和${this._selectPeople}正式入住恋爱屋，快来攒钱吧！`;
        }
    }

    /**
     * 恭喜 确认
     */
    onBtnCongratulationMakeSure(){
        this.congratulationsNode.active = false;
        NormalGameManager._instance.loveStroyManager.addOnePeople( this._selectPeople );
        this.closeThis();
    }

    /**
     * 恭喜取消
     */
    onBtnCongratulationCancel(){
        this.congratulationsNode.active = false;
        NormalGameManager._instance.loveStroyManager.addOnePeople( this._selectPeople );
        this.closeThis();
    }

}
